import src from "IMAGE";
export default { src, width: 200, height: 200, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAHUlEQVR42uXKIQEAAADCsPe3pL2jAQUQc0PNwkcobAXfgeQ49KwAAAAASUVORK5CYII="};
